import { ErrorDialogComponent } from './../error-dialog/error-dialog.component';
import { ProjectDataService } from './../services/project-data.service';
import { DataService } from './../services/data.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gas-project-dialog',
  templateUrl: './gas-project-dialog.component.html',
  styleUrls: ['./gas-project-dialog.component.scss']
})
export class GasProjectDialogComponent implements OnInit {

  gasProjectSelection: string;
  movingToProjectScreen: boolean;

  constructor(public dialogRef: MatDialogRef<GasProjectDialogComponent>,
    private router: Router, private dataService: DataService, private projectDataService: ProjectDataService,
    private dialog: MatDialog) { }

  ngOnInit() {
    this.gasProjectSelection = '';
    this.movingToProjectScreen = false;
  }

  closeDialog() {
    if (!this.movingToProjectScreen) {
      this.dialogRef.close();
    }
  }

  goToProjectScreen() {
    this.movingToProjectScreen = true;
    this.dataService.getEcosysData().subscribe((result) => {
      this.projectDataService.ecosysData = result.CostObjectList;
      this.movingToProjectScreen = false;
      this.dialogRef.close();
      this.router.navigate(["/funding-project"]);
    }, error => {
      this.movingToProjectScreen = false;
      console.log('error', error);
      let errorType = '';
      let errorDescription = '';
      if (error.error.message) {
        errorDescription = errorDescription.concat('Get Ecosys Data Error - ', error.error.message);
      }
      else {
        errorDescription = errorDescription.concat('Get Ecosys Data Error');
      }
      errorType = errorType.concat(error.status, ' ', error.statusText)
      let dataStructure = {
        errorType: errorType,
        errorDescription: errorDescription
      };
      this.dialog.open(ErrorDialogComponent, {
        data: dataStructure,
        disableClose: true
      });
    });
  }

}
